import { formatCurrency } from 'utils';

export const EMPTY_VALUE = '—';

export const getChangeAction = <T>(
  before: T | null | undefined,
  after: T | null | undefined
): 'added' | 'removed' | 'updated' => {
  if (before === null && after !== null) return 'added';
  if (before !== null && after === null) return 'removed';

  return 'updated';
};

export const formatCurrencyText = (value: number | null | undefined): string => {
  if (value === null) return EMPTY_VALUE;

  return formatCurrency(value, true) || '$0';
};

export const formatEnumText = (value: string | null | undefined): string => {
  if (!value) return EMPTY_VALUE;

  return value
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const formatBooleanText = (value: boolean | null | undefined): string => {
  if (value === null) return EMPTY_VALUE;

  return value ? 'Yes' : 'No';
};

export const getFeeAmount = (value: Record<string, any> | null | undefined): number | null | undefined =>
  value?.price?.total;

export const formatCapText = (cap: Record<string, any>): string => {
  if (!cap) return EMPTY_VALUE;
  return `${formatCurrencyText(cap.min)} - ${formatCurrencyText(cap.max)}`;
};
